import React from 'react';
import { store } from '../../../../store';
import Dante from '../Editor/components/Dante/Dante';
const AboutSection = (onContent) => {
  if(store.getState().activities.edit)
      { 
        return (<Dante
        widgets={[]}
        />)
      }
      else
      { 
        let content = store.getState().about.content
        return (
                              <p dangerouslySetInnerHTML={{__html: content}} />)
      }
}
export default AboutSection